export const formatAddress = (address, number, floor, apartment, postalCode) => {
  let string = address
  if (number) string += ` ${number}`
  if (floor || apartment) string += ' |'
  if (floor) string += ` ${floor}`
  if (apartment) string += ` ${apartment}`
  return string
}

export const formatNumber = number => number
  .toFixed(2) // always two decimal digits
  .replace('.', ',') // replace decimal point character with ,
  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')

export const formatNoDecimal = number => number
  .toFixed(0) // always two decimal digits
  .replace('.', ',') // replace decimal point character with ,
  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')



// WEBPACK FOOTER //
// ./src/common/format.js